<template>
  <div class="club-nav-comp">
    <div class="club-nav-header">{{ getPageDict(2) /* 战队 */ }}</div>
    <div class="club-nav-list" ref="navList" @scroll="updateNavDomScrollTop">
      <div
        class="club-nav-item"
        :class="(curClub || {}).id == clubItem.id ? 'active' : ''"
        v-for="(clubItem, index) in clubList"
        :key="index"
        :style="{
          backgroundImage: `url(${clubItem.logo})`,
        }"
        @click="switchClub(clubItem)"
      ></div>
    </div>
  </div>
</template>

<script>
import { getPageDictInit, bus } from "@/common";
import { mapState, mapGetters } from "vuex";
const getPageDict = getPageDictInit("eSport");

export default {
  name: "clubNav",
  props: {},
  data() {
    return {
      navDomScrollTop: 0,
    };
  },
  computed: {
    ...mapState({
      clubList: (state) => state.clubPage.clubList,
      navScrollTop: (state) => state.clubPage.clubNavCompScrollTop || 0,
    }),
    ...mapGetters({
      curClub: "clubPage/curClub",
    }),
  },
  watch: {},
  methods: {
    getPageDict,
    updateNavDomScrollTop() {
      this.navDomScrollTop = this.$refs.navList.scrollTop;
    },
    switchClub(club) {
      this.$store.dispatch("clubPage/switchCurClub", club.id);
    },
    scrollToCurClub() {
      // let itemHeight =
    },
  },
  components: {},
  created() {},
  mounted() {
    // console.log(this.navScrollTop);
    if (this.$refs.navList) {
      this.$refs.navList.scrollTop = this.navScrollTop;
    }
  },
  beforeDestroy() {
    // console.log(this.navDomScrollTop);
    this.$store.commit(
      "clubPage/setClubNavCompScrollTop",
      this.navDomScrollTop
    );
  },
};
</script>

<style lang="scss" scoped>
.club-nav-comp {
  // border:2px solid #f00;
  width: 1.54rem;
  flex-shrink: 0;
  // height: 100%;
  display: flex;
  flex-direction: column;
  $header-content-height: 0.51rem;
  $header-bg-height: 0.61rem;
  .club-nav-header {
    height: $header-bg-height;
    line-height: $header-content-height;
    background-image: url(../../imgs/club-head-bg.png);
    background-repeat: no-repeat;
    background-size: 100%;
    font-size: 0.22rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: $header-content-height - $header-bg-height;
    z-index: 5;
  }
  .club-nav-list {
    flex: 1;
    height: 0;
    background-image: url(../../imgs/club-list-bg.png);
    background-size: 100%;
    background-position-y: bottom;
    overflow: auto;
    position: relative;

    .club-nav-item {
      $size: 0.9rem;
      width: $size;
      height: $size;
      margin: 0.12rem auto;
      background-color: rgba(0, 0, 0, 0.2);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;

      &:first-child {
        margin-top: 0.14rem;
      }
      &:last-child {
        margin-bottom: 0.14rem;
      }
      &.active::after {
        transform: scale(1.05);
        display: inline-block;
        box-sizing: border-box;
        content: "";
        width: 100%;
        height: 100%;
        border: 0.04rem solid rgba(#ffbb1c, 0.9);

        box-shadow: inset 0rem 0rem 0.03rem#ffbb1c, 0rem 0rem 0.03rem#ffbb1c;
      }
    }
  }
}
</style>
